import templateStr from 'text!./templates/confirmation.html';
import 'edge/quoteandbind/common/app';

export default [() => {
    return {
        restrict: 'A',
        template: templateStr
    };
}];